import Cookies from 'js-cookie'

function onBeforePrint() {
  if (Cookies.get("PrintingAllowed") != "Y") {
    var alltags = document.getElementsByTagName("*");
    for (let i = 0; i < alltags.length; i++) {
      if (alltags[i].style.display != "none") {
        alltags[i].printHidden = "yes";
        alltags[i].style.display = "none";
      }
    }
  }
}

function onAfterPrint() {
  if (Cookies.get("PrintingAllowed") != "Y") {
    var alltags = document.getElementsByTagName("*");
    for (let i = 0; i < alltags.length; i++) {
      if (
        alltags[i].style.display == "none" &&
        alltags[i].printHidden == "yes"
      ) {
        alltags[i].printHidden = "";
        alltags[i].style.display = "";
      }
    }
  }
}

function onContextMenu() {
  if (Cookies.get("PrintingAllowed") != "Y") {
    return false;
  }
}

function onSelect() {
  if (Cookies.get("PrintingAllowed") != "Y") {
    document.selection.empty();
  }
}
function onCopy() {
  if (Cookies.get("PrintingAllowed") != "Y") {
    document.selection.empty();
  }
}

export default function initialize() {
  // please note that the handlers are assigned immediately, but the value from the cookie is read on each event occurence
  // this means that the script doesn't need to rerun when the cookie changes
  window.onbeforeprint = onBeforePrint;
  window.onafterprint = onAfterPrint;
  document.oncontextmenu = onContextMenu;
  document.onselect = onSelect;
  document.oncopy = onCopy;
}
